export default __webpack_public_path__ + "static/media/jika-club-card.fb48f49c.png";